// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import {Checkbox, Switch, Tree} from "antd";

// Import Styles
import '../../assets/styles/containerStyles/page-add-edit.scss';
import '../../assets/styles/components/medias-list-wrapper.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import { InputGroup } from "../../components/uiElements/inputGroup";
import { LinkButton } from "../../components/buttons/buttons";
import { LanguageTabs } from "../../components/uiElements/Tabs";
import { Editor } from "../../components/uiElements/Editor";
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import { MediaFileCard } from "../../components/media/MediaFileCard";


// Import utils
import { mapStateToProps } from "../../redux/mapStateToProps";
import {
    arraysEquals,
    changeStateField,
    getInputValues,
    getPatchReqData,
    getPostReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import { AddBrand, GetBrandById, UpdateBrand, } from "../../redux/actions";
import { validateTranslations } from "../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../constants/acceptedTypes";
import { MEDIA_MODAL_TYPES, } from "../../constants/constTypes";
import { history } from "../../configs/history";
import {generateImageMediaUrl} from "../../utils/generateMemberMediaUrl";
import {MaterialIcon} from "../../components/utils/Icon";

class AddEditBrand extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                categories: [],
                coverMedia: undefined,
                type: undefined,
                slug: '',
                isHidden: false,
            },
            checkedId : '',
            btnDisabled:false,
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            mediaModalType: null,
            categoriesMediaModalType: null,
            requestLoading: false,
        };
        this.myRef = React.createRef();
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.getPostReqData = getPostReqData.bind(this);

        this.toggleMediaModal = changeStateField.bind(this, 'mediaModalType');
        this.toggleCategoriesMediaModal = changeStateField.bind(this, 'categoriesMediaModalType');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);

        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.getCategoriesMedia = this.getCategoriesMedia.bind(this);
        this.deleteCategoriesMedia = this.deleteCategoriesMedia.bind(this);

        this.addEditBrand = this.addEditBrand.bind(this);
        this.onChange= this.onChange.bind(this);
    }

    async componentDidMount () {
        const { isEditing, fieldsData } = this.state;
        if (isEditing) {
            const translationsData = {};
            const editingData = await this.props.GetBrandById(this.props.id)
            if (!editingData) {
                history.push('/brand');
                return;
            }

            if (editingData) {
                Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = editingData?.translations?.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        title: trItem?.title || '',
                        description: trItem?.description || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                slug: editingData?.slug || '',
                type: editingData?.type?.id || undefined,
                mediaMain: editingData?.mediaMain,
                coverMedia: editingData?.coverMedia,
                isHidden: editingData?.isHidden,
                categories : editingData.categories.map(item => {
                    return {
                        category: item?.category?.id || '',
                        mediaMain: item?.mediaMain || ' '
                    }
                }) || [],
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getMedia (mediaArray, mediaType) {
        const { fieldsData, errors, isEditing, mediaModalType } = this.state;
        if (isEditing) {
            this.currentData?.[mediaModalType]?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set(mediaModalType, mediaArray[0]?.id)
                : this.updatedDataMap.delete(mediaModalType);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [mediaModalType]:  mediaArray[0],
            },
            errors: {
                ...errors,
                [mediaModalType]: false
            }
        })
    }

    getCategoriesMedia (mediaArray, mediaType,selected) {
        const { fieldsData, errors, isEditing, mediaModalType,checkedId } = this.state;
        // console.log(checkedId,'mediaType')
        // if (isEditing) {
        //     this.currentData?.[mediaModalType]?.id !== mediaArray[0]?.id
        //         ? this.updatedDataMap.set(mediaModalType, mediaArray[0]?.id)
        //         : this.updatedDataMap.delete(mediaModalType);
        // }
        this.setState({
            fieldsData: {
                ...fieldsData,
                categories:fieldsData.categories.map((item,index) => (
                    {
                        ...fieldsData.categories[index],
                        mediaMain: item.category === checkedId ? mediaArray[0] : item.mediaMain
                    }
                ))
            },
            errors: {
                ...errors,
                [mediaModalType]: false
            }
        })
    }

    deleteCategoriesMedia (type, id) {
        const { fieldsData, isEditing } = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            this.currentData?.[type] ?
                this.updatedDataMap.set(type, null) :
                this.updatedDataMap.delete(type);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null
            }
        })
    }
    deleteMedia (type, id) {
        const { fieldsData, isEditing } = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            this.currentData?.[type] ?
                this.updatedDataMap.set(type, null) :
                this.updatedDataMap.delete(type);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null
            }
        })
    }

    mediaCardWrapper (data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={this.deleteMedia.bind(this, 'medias', data?.item?.media?.id)}/>
    }

    async addEditBrand () {
        await this.setState({
            requestLoading: true
        });
        const { fieldsData } = this.state;
        const { translations, mediaMain, coverMedia, type, slug, isHidden,categories } = fieldsData;
        const translationRequiredFields = ['title',]
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }
        if (!coverMedia) {
            errors.coverMedia = true;
            result = false;
        }

        if (!slug) {
            errors.slug = true;
            result = false;
        }

        if (!type) {
            errors.type = true;
            result = false;
        }

        if (result) {
            if (!this.state.isEditing) {
                const reqData = this.getPostReqData(fieldsData);
                reqData.isHidden = isHidden
                reqData.categories = categories.map(item => {
                    return {
                        category: item?.category || '',
                        mediaMain: item?.mediaMain?.id || ' '
                    }
                })
                console.log('reqData', reqData)
                this.props.AddBrand(reqData).finally(() => {
                    this.setState({ requestLoading: false });
                })
            } else {
                const trData = getTranslationData(translations);
                const reqData = this.getPatchReqData(trData);
                reqData.categories = categories.map(item => {
                    return {
                        category: item?.category || '',
                        mediaMain: item?.mediaMain?.id || ' '
                    }
                })
                console.log('trData', reqData)
                this.props.UpdateBrand(this.props.id, reqData)
                    .finally(() => {
                        this.setState({ requestLoading: false });
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

   onChange (id,e)  {
        this.setState({
            ...this.state,
            checkedId:id
        })
        const {fieldsData} = this.state
        if(!e.target.checked){
            this.setState({
                fieldsData: {
                    ...fieldsData,
                    categories:fieldsData.categories.filter(item => item.category !== id)
                }
            })
        }else {
            this.setState({
                fieldsData: {
                    ...fieldsData,
                    categories:[
                        ...fieldsData.categories,
                        {
                            category:id,
                            mediaMain:null,
                        }
                    ]
                }
            })
        }
    }

    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalType,
            categoriesMediaModalType,
            requestLoading,
            isEditing,
            errorsTabs
        } = this.state;
        const {categoriesList} = this.props
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData?.translations[languageTab] || {};
        const typesOptions = this.props?.brandTypesList.map(type => {
            return {
                id: type?.id,
                title: type?.title || ' '
            }
        });

        console.log(fieldsData.categories,'fieldsData.categories')


        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Բրենդ' : 'Փոփոխել Բրենդը'}>
            <section className="page-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար քարտ <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'mediaMain')}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                    <div>
                        <div className="top-side">
                            <label>Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.coverMedia ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'coverMedia')}
                            />
                        </div>
                        {fieldsData?.coverMedia && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.coverMedia}
                                           customDelete={() => this.deleteMedia("coverMedia")}
                            />
                        </div>}
                    </div>
                </div>
                <InputGroup inputType="selectCustom"
                            label={"Բրենդի տեսակ"}
                            placeholder="Բրենդի տեսակ"
                            name="type"
                            showSearch={false}
                            value={fieldsData?.type}
                            initValue={this.currentData?.type}
                            required={true}
                            error={errors['type']}
                            onChange={this.getInputValues}
                            options={typesOptions}
                />
                <InputGroup inputType="input"
                            type="text"
                            label="Slug"
                            placeholder="Slug"
                            name="slug"
                            value={fieldsData.slug}
                            initValue={this.currentData?.slug}
                            error={errors['slug']}
                            maxLength={50}
                            required={true}
                            onChange={this.getInputValues}/>
                <div className="tree-item">
                    <label>Կատեգորիաներ</label>
                    {
                        categoriesList.map((item,index) => {
                            const selected = fieldsData?.categories.find(data => data.category === item.id)
                            return <div className={'category-wrapper'}>
                                <Checkbox onChange={(e) => this.onChange(item.id,e)}
                                          checked={!!selected}>
                                    {item?.title}
                                </Checkbox>
                                <div>
                                    <div className="top-side" >
                                        <div className={`category-img ${!selected ? 'error' : ''}`}
                                             onClick={this.toggleCategoriesMediaModal.bind(this, 'mediaMain')}
                                        >
                                            <MaterialIcon icon={'photo_library'}/> <span className={'required-badge'}>*</span>
                                        </div>
                                    </div>
                                    {!!selected && <div className={`category-media`}>
                                        {fieldsData?.categories[index]?.mediaMain?.path && <img
                                            src={generateImageMediaUrl(fieldsData?.categories[index]?.mediaMain?.path)}
                                            alt=""/>}
                                    </div>}
                                </div>
                            </div>
                        })
                    }
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div className="brand-wrapper">
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={256}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <div className="editor-wrapper">
                        <label>Նկարագրություն</label>
                        <Editor value={currentData?.description || ''}
                                name={'description'}
                                initValue={initData?.description}
                                error={errors['description' + languageTab]}
                                onChange={this.getTranslationValues}/>
                    </div>

                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                cb={this.addEditBrand}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                mediaType={MEDIA_MODAL_TYPES.MEDIA_MAIN}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            <MediaSelectorModal
                isOpen={!!categoriesMediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                mediaType={MEDIA_MODAL_TYPES.MEDIA_ARRAY}
                getMedia={this.getCategoriesMedia}
                closeModal={this.toggleCategoriesMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBrandById,
    AddBrand,
    UpdateBrand,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditBrand)
